import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

// Ícone X de fechar — usado por ChatiaDialog e drawers (tamanho padrão 18px)
export const CloseXIcon = (props) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path d="M18 6L6.00081 17.9992M17.9992 18L6 6.00085" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</SvgIcon>
);

// Ícone de check — usado por PopoverOptionItem, SaveButton, etc.
export const CheckIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
		<path d="M5 14L8.5 17.5L19 6.5" />
	</svg>
);

// Ícone de seta para Select (dropdown) — marginTop/marginRight ajustado por quem usa
export const SelectArrowIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
		<path d="M6 9L12 15L18 9" />
	</svg>
);

// Ícone de editar (lápis)
export const EditPenIcon = (props) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path d="M15.2141 5.98239L16.6158 4.58063C17.39 3.80646 18.6452 3.80646 19.4194 4.58063C20.1935 5.3548 20.1935 6.60998 19.4194 7.38415L18.0176 8.78591M15.2141 5.98239L6.98023 14.2163C5.93493 15.2616 5.41226 15.7842 5.05637 16.4211C4.70047 17.058 4.3424 18.5619 4 20C5.43809 19.6576 6.94199 19.2995 7.57889 18.9436C8.21579 18.5877 8.73844 18.0651 9.78375 17.0198L18.0176 8.78591M15.2141 5.98239L18.0176 8.78591" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M11 20H17" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</SvgIcon>
);
